/**
 * Handles membership offer page interactions — selecting a subscription plan,
 * toggling UI state, and posting the selection to the server.
 */
export class MembershipOffer {
    /**
     * Create a MembershipOffer instance and bind click handlers to subscription buttons.
     *
     * @param {string} subscriptionButtons - CSS selector for the subscription plan buttons.
     * @param {string} basketButton - CSS selector for the header basket element.
     */
    constructor(subscriptionButtons, basketButton) {
        const addSubButtons = document.querySelectorAll(subscriptionButtons);
        const headerBasket = document.querySelector(basketButton);

        if (addSubButtons.length === 0 || !basketButton) {
            return;
        }

        this.init(addSubButtons, headerBasket);
    }

    /**
     * Attach click listeners to each subscription button.
     *
     * @param {NodeListOf<Element>} addSubButtons - The subscription plan button elements.
     * @param {Element | null} headerBasket - The header basket element (may be null).
     * @returns {void}
     */
    init(addSubButtons, headerBasket) {
        addSubButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                const el = /** @type {HTMLElement} */ (e.target);
                const id = el.dataset.id;
                const offerKey = el.dataset.offer;
                const buttonText = el.dataset.buttonText;
                const buttonTextSelected = el.dataset.buttonTextSelected;
                const membershipSwiperSlide = el.closest(".swiper-slide");
                const addedToBasketToast = document.querySelector(
                    `.lux-toast.membership-type-${id}`,
                );

                if (
                    headerBasket &&
                    !headerBasket.classList.contains("active")
                ) {
                    headerBasket.classList.add("active");
                    headerBasket
                        .querySelector(".header-button-counter")
                        ?.classList.add("sub-only");
                }

                if (addedToBasketToast) {
                    luxPopup.toastShow(addedToBasketToast);
                }

                const membershipsSection = document.querySelector(
                    ".page-membership-offer .section-memberships",
                );
                if (membershipsSection) {
                    membershipsSection.classList.add("membership-selected");
                }

                document
                    .querySelectorAll(
                        ".page-membership-offer .section-memberships .swiper-slide",
                    )
                    .forEach((slideEl) => slideEl.classList.remove("selected"));

                addSubButtons.forEach((btnEl) => {
                    btnEl.classList.remove("disabled");
                    btnEl.innerHTML = buttonText ?? "";
                });

                el.classList.add("disabled");
                el.innerHTML = buttonTextSelected ?? "";

                if (membershipSwiperSlide) {
                    membershipSwiperSlide.classList.add("selected");
                }

                fetch(`/membership/offer/${id}/${offerKey}`)
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.success !== true) {
                            el.innerHTML = "Error";
                        }
                    });
            });
        });
    }
}
